import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch astrologers for dropdown  (id + name)
export const getAstrologersForDropdown = async () => {
  try {
    const response = await api.get(`${API_URL}/astrologers/dropdown_list`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Fetch astro payment link history
// Accepted query params: astrologerId, page, limit, status, startDate, endDate, search
export const getAstroPaymentLinkHistory = async (params = {}) => {
  try {
    const query = {
      page:  params.page  || 1,
      limit: params.limit || 20,
    };

    if (params.astrologerId) query.astrologerId = params.astrologerId;
    if (params.status)       query.status       = params.status;
    if (params.startDate)    query.startDate    = params.startDate;
    if (params.endDate)      query.endDate      = params.endDate;
    if (params.search)       query.search       = params.search;
    if (params.sortOrder)    query.sortOrder    = params.sortOrder;

    const response = await api.get(
      `${API_URL}/astrologers/payment_link_history`,
      { params: query }
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};